import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

// Template140: Metro de Seúl
// Contenido desde page (texts, canvasImages). Sin fallbacks.
const Template140 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const subwayImage = getCanvasImageUrl("subway");
	const logoImage = getCanvasImageUrl("logo");

	const intro = page?.texts?.[1]?.content;
	const tmoney = page?.texts?.[2]?.content;
	const appsTitle = page?.texts?.[3]?.content;
	const appsList = page?.texts?.[4]?.content;
	const tipRecarga = page?.texts?.[5]?.content;
	const lineas = page?.texts?.[6]?.content;
	const horario = page?.texts?.[7]?.content;

	let actualHeaderColor = headerBackgroundColor || "#2E8B80";

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{intro && (
				<Box data-block-id="text-1" sx={{ padding: "16px", fontSize: 13, color: "#444", position: "relative" }}>
					<Box component="p" sx={p}>
						{intro}
					</Box>
				</Box>
			)}

			<Box
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: "12px",
				}}
			>
				{tmoney && (
					<Box
						data-block-id="text-2"
						sx={{
							backgroundColor: "#fff",
							borderRadius: "12px",
							padding: "12px 14px",
							display: "flex",
							alignItems: "center",
							gap: "10px",
							border: "2px solid #d9e6de",
						}}
					>
						<Box sx={{ fontSize: 18 }}>💳</Box>
						<Box sx={{ fontSize: 13, color: "#444" }} dangerouslySetInnerHTML={{ __html: tmoney }} />
					</Box>
				)}

				{(appsTitle || appsList) && (
					<Box
						data-block-id="text-3"
						sx={{
							backgroundColor: "#caeae6",
							border: "3px solid #2e8b80",
							borderRadius: "12px",
							padding: "12px 14px",
							fontSize: 13,
							fontFamily: "'Poppins', sans-serif",
							color: "#333",
							position: "relative",
						}}
					>
						{appsTitle && (
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: "8px",
									fontSize: 13,
									fontWeight: 700,
									color: "#2e8b80",
									textTransform: "uppercase",
								}}
							>
								{appsTitle}
							</Box>
						)}
						{appsList && (
							<Box sx={{ lineHeight: 1.5 }} dangerouslySetInnerHTML={{ __html: appsList }} />
						)}
						{!isSmallScreen && subwayImage && (
							<Box sx={{ padding: "0 16px", position: "absolute", bottom: -140, right: 0 }}>
								<img
									src={subwayImage}
									alt="Mapa del metro de Seúl"
									style={{ width: "100px", borderRadius: 12, marginBottom: 16 }}
								/>
							</Box>
						)}
						{!isSmallScreen && tipRecarga && (
							<Box
								sx={{
									position: "absolute",
									top: 30,
									right: 30,
									backgroundColor: "#fff8db",
									border: "2px solid #f5c400",
									borderRadius: "16px 16px 0px 16px",
									padding: "10px 12px",
									fontSize: 11,
									color: "#444",
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: 120,
								}}
							>
								<span dangerouslySetInnerHTML={{ __html: tipRecarga }} />
							</Box>
						)}
					</Box>
				)}

				{lineas && (
					<Box
						data-block-id="text-4"
						sx={{
							backgroundColor: "#fff",
							borderRadius: "12px",
							padding: "12px 14px",
							display: "flex",
							alignItems: "center",
							gap: "10px",
							border: "2px solid #d9e6de",
						}}
					>
						<Box sx={{ fontSize: 18 }}>🚇</Box>
						<Box sx={{ fontSize: 13, color: "#444" }} dangerouslySetInnerHTML={{ __html: lineas }} />
					</Box>
				)}

				{horario && (
					<Box
						data-block-id="text-5"
						sx={{
							backgroundColor: "#fff",
							borderRadius: "12px",
							padding: "12px 14px",
							display: "flex",
							alignItems: "center",
							gap: "10px",
							border: "2px solid #d9e6de",
						}}
					>
						<Box sx={{ fontSize: 18 }}>⏰</Box>
						<Box sx={{ fontSize: 13, color: "#444" }} dangerouslySetInnerHTML={{ __html: horario }} />
					</Box>
				)}
				{isSmallScreen && subwayImage && tipRecarga && (
					<Box sx={{ position: "relative" }}>
						{isSmallScreen && subwayImage && (
							<Box sx={{ padding: "0 16px", position: "absolute", bottom: -140, right: 0 }}>
								<img
									src={subwayImage}
									alt="Mapa del metro de Seúl"
									style={{ width: "100px", borderRadius: 12, marginBottom: 16 }}
								/>
							</Box>
						)}
						{isSmallScreen && tipRecarga && (
							<Box
								sx={{
									position: "absolute",
									top: -24,
									right: 30,
									backgroundColor: "#fff8db",
									border: "2px solid #f5c400",
									borderRadius: "16px 16px 0px 16px",
									padding: "10px 12px",
									fontSize: 11,
									color: "#444",
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: 220,
								}}
							>
								<span dangerouslySetInnerHTML={{ __html: tipRecarga }} />
							</Box>
						)}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template140.thumbnail = "/images/template-1.png";

export default Template140;
